

  import { defineComponent,ref} from 'vue';
  import { ElConfigProvider } from 'element-plus';
  import {IsPhone} from '@/utils/checkPhone'
  const IsPhoneFlag = ref(IsPhone())

 export default defineComponent({
    components:{
      ElConfigProvider,
    },
    provide: {
      IsPhoneFlag: IsPhoneFlag // 判断该设备是否是手机端
    },
    setup(){
      return {
        zIndex:3000,
        size:'small'
      }
    }
 }) 
